import type { SqlSnippetTemplate } from './sqlSnippetTemplateTypes';

export function getBuiltInSqlSnippetTemplatesPlsql(): readonly SqlSnippetTemplate[] {
  return [
    {
      id: 'plsql-anonymous-block',
      label: 'PL/SQL anonymous block (BEGIN…END)',
      detail: 'Built-in snippet',
      documentation: 'PL/SQL anonymous block template',
      filterText: 'begin end plsql block anonymous',
      insertText: 'BEGIN\n  ${1:NULL;}\nEND;\n/',
    },
    {
      id: 'plsql-declare-block',
      label: 'PL/SQL DECLARE block',
      detail: 'Built-in snippet',
      documentation: 'PL/SQL block with DECLARE section',
      filterText: 'declare begin end plsql variable',
      insertText:
        'DECLARE\n  ${1:v_result} ${2:NUMBER};\nBEGIN\n  ${3:NULL;}\nEND;\n/',
    },
    {
      id: 'plsql-cursor-for-loop',
      label: 'PL/SQL cursor FOR loop',
      detail: 'Built-in snippet',
      documentation: 'Implicit cursor FOR loop template',
      filterText: 'cursor for loop select plsql',
      insertText:
        'BEGIN\n  FOR rec IN (\n    SELECT ${1:*}\n    FROM ${2:table}\n    WHERE ${3:1=1}\n  ) LOOP\n    DBMS_OUTPUT.PUT_LINE(rec.${4:column});\n  END LOOP;\nEND;\n/',
    },
    {
      id: 'plsql-exception-handling',
      label: 'PL/SQL exception handling',
      detail: 'Built-in snippet',
      documentation: 'PL/SQL block with EXCEPTION handlers',
      filterText: 'exception when others no_data_found too_many_rows',
      insertText:
        'BEGIN\n  ${1:NULL;}\nEXCEPTION\n  WHEN NO_DATA_FOUND THEN\n    ${2:NULL;}\n  WHEN TOO_MANY_ROWS THEN\n    ${3:NULL;}\n  WHEN OTHERS THEN\n    DBMS_OUTPUT.PUT_LINE(\'Error: \' || SQLERRM);\n    RAISE;\nEND;\n/',
    },
    {
      id: 'plsql-bulk-collect',
      label: 'PL/SQL BULK COLLECT',
      detail: 'Built-in snippet',
      documentation: 'BULK COLLECT into collection template',
      filterText: 'bulk collect into table type plsql',
      insertText:
        'DECLARE\n  TYPE t_${1:table}_tab IS TABLE OF ${2:table}%ROWTYPE;\n  l_data t_${1:table}_tab;\nBEGIN\n  SELECT *\n  BULK COLLECT INTO l_data\n  FROM ${2:table}\n  WHERE ${3:1=1};\n\n  DBMS_OUTPUT.PUT_LINE(\'Rows fetched: \' || l_data.COUNT);\nEND;\n/',
    },
    {
      id: 'plsql-forall',
      label: 'PL/SQL FORALL bulk DML',
      detail: 'Built-in snippet',
      documentation: 'FORALL bulk DML template',
      filterText: 'forall bulk insert update delete plsql',
      insertText:
        'DECLARE\n  TYPE t_id_tab IS TABLE OF NUMBER;\n  l_ids t_id_tab := t_id_tab(${1:1, 2, 3});\nBEGIN\n  FORALL i IN 1..l_ids.COUNT\n    ${2:DELETE FROM table WHERE id = l_ids(i)};\n\n  DBMS_OUTPUT.PUT_LINE(SQL%ROWCOUNT || \' rows affected\');\nEND;\n/',
    },
    {
      id: 'plsql-ref-cursor',
      label: 'PL/SQL REF CURSOR',
      detail: 'Built-in snippet',
      documentation: 'REF CURSOR (SYS_REFCURSOR) template',
      filterText: 'ref cursor sys_refcursor open fetch close',
      insertText:
        'DECLARE\n  l_cursor SYS_REFCURSOR;\n  l_${1:name} ${2:VARCHAR2(100)};\nBEGIN\n  OPEN l_cursor FOR\n    SELECT ${3:column} FROM ${4:table};\n\n  LOOP\n    FETCH l_cursor INTO l_${1:name};\n    EXIT WHEN l_cursor%NOTFOUND;\n    DBMS_OUTPUT.PUT_LINE(l_${1:name});\n  END LOOP;\n\n  CLOSE l_cursor;\nEND;\n/',
    },
    {
      id: 'plsql-pipelined-function',
      label: 'PL/SQL pipelined function',
      detail: 'Built-in snippet',
      documentation: 'Pipelined table function template',
      filterText: 'pipelined function pipe row table',
      insertText:
        'CREATE OR REPLACE TYPE ${1:t_row} AS OBJECT (\n  ${2:col1} VARCHAR2(100),\n  ${3:col2} NUMBER\n);\n/\n\nCREATE OR REPLACE TYPE ${4:t_tab} AS TABLE OF ${1:t_row};\n/\n\nCREATE OR REPLACE FUNCTION ${5:fn_name}\nRETURN ${4:t_tab} PIPELINED AS\nBEGIN\n  FOR rec IN (SELECT ${2:col1}, ${3:col2} FROM ${6:table}) LOOP\n    PIPE ROW(${1:t_row}(rec.${2:col1}, rec.${3:col2}));\n  END LOOP;\n  RETURN;\nEND ${5:fn_name};\n/',
    },
  ] as const;
}
